import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=6c3091b5&"
import script from "./DynamicModal.vue?vue&type=script&lang=ts&"
export * from "./DynamicModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports